// HR reports (Demographics, Anniversary, Retention). The API returns one flat row per person and the
// client does every count, so a selection in one chart can filter the other charts and tables.

export interface HrReportRow {
    id: string
    name: string
    email: string | null
    jobTitle: string | null
    positionType: string
    employeeType: string | null
    department: string | null
    division: string | null
    officeLocation: string | null
    manager: string | null
    managerId: string | null
    gender: string | null
    identity: string | null
    indigenous: boolean
    esaExempt: boolean
    designations: string[]
    hireDate: string | null
}

export interface HrRetentionRow extends HrReportRow {
    terminatedAt: string
    reason: string | null
    yearsOfService: number | null
}

export interface HrRetentionReport {
    fiscalYear: number
    fiscalYears: number[]
    rows: HrRetentionRow[]
}

// Label used for a missing value in charts, tables and filters
export const NOT_SET = "Not set"

export const yesNo = (value: boolean) => (value ? "Yes" : "No")

// Employee type that the department table counts as Co-ops (EmployeeType.name)
export const COOP_EMPLOYEE_TYPE = "Coop"
